import { Link } from 'react-router-dom';
type Props = {
  to: string;
  title?: string;
  newTab?: boolean;
}
export const OpenIconLink = ({ to, title, newTab }: Props) =>  <Link to={to} target={newTab ? '_blank' : '_self'}  className="text-indigo-300 hover:text-indigo-700"><i className="fas fa-search fa-1x" title={title || 'Ouvrir'}/></Link>;
